// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IClaimFileModel {
    static getAttributeTypeMap() {
        return IClaimFileModel.attributeTypeMap;
    }
}
IClaimFileModel.discriminator = undefined;
IClaimFileModel.additionalProperties = false;
IClaimFileModel.attributeTypeMap = [
    {
        "name": "fileContents",
        "baseName": "fileContents",
        "type": "string"
    },
    {
        "name": "fileName",
        "baseName": "fileName",
        "type": "string"
    },
];
//# sourceMappingURL=iClaimFileModel.js.map